import type { ReactNode } from "react";
import { isFeatureAllowed, type GatedFeature } from "@lucralink/shared";
import { PageHeader } from "@/components/PageHeader";
import { UpgradePrompt } from "@/components/billing/UpgradePrompt";
import { useEntitlements } from "@/lib/entitlements";
import { useTenant } from "@/lib/hooks/useTenant";

interface PlanGateProps {
  readonly feature: GatedFeature;
  readonly title: string;
  readonly subtitle: string;
  readonly children: ReactNode;
}

/** Tela inteira travada por plano: mostra o cabecalho e o upsell no lugar do
 *  conteudo. O enforcement real fica no banco (triggers/RLS); isto e UX. */
export function PlanGate({ feature, title, subtitle, children }: PlanGateProps): JSX.Element {
  const { data, isLoading } = useTenant();
  const entitlements = useEntitlements(data?.tenant);

  if (isLoading) {
    return <div className="h-40 animate-pulse rounded-xl border border-border bg-card" aria-busy="true" />;
  }
  if (!isFeatureAllowed(entitlements, feature)) {
    return (
      <div className="max-w-3xl space-y-6">
        <PageHeader title={title} subtitle={subtitle} />
        <UpgradePrompt reason={feature} />
      </div>
    );
  }
  return <>{children}</>;
}
